import * as React from 'react';
import classnames from 'classnames';
import { Loader } from 'Components/General/Loader';

export const TableLoader = ({ loading, style }: { loading: boolean, style?: React.CSSProperties }) => {
  const clName = classnames('scrollable-table-loader', { 'scrollable-table-loading': loading });
  return (
    <div className={clName} style={style}>
      <Loader />
    </div>
  );
};